// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderComp_loaderWrapper__mFIVw","cubeWrapper":"LoaderComp_cubeWrapper__BsFnN","cube":"LoaderComp_cube__Vc-eu","rotateCube":"LoaderComp_rotateCube__8Hg+b"};